import React, { useEffect, useState } from 'react'
import { Checkbox, Spin, Alert, notification } from 'antd'
import { CCard } from '@coreui/react'
import { apiRequest } from '../../helpers/apiRequest'

const apiUrl = process.env.REACT_APP_API

const Parametri = () => {
  const [params, setParams] = useState(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    apiRequest(`${apiUrl}parametri`, 'GET')
      .then(res => setParams(res))
      .catch(() => setError('Nu s-au putut încărca parametrii.'))
      .finally(() => setLoading(false))
  }, [])

  const handleChange = async (field, value) => {
    setSaving(true)
    try {
      const res = await apiRequest(`${apiUrl}parametri`, 'PATCH', { [field]: value })
      setParams(res)
      notification.success({ message: 'Parametru salvat.' })
    } catch {
      notification.error({ message: 'Eroare la salvare.' })
    } finally {
      setSaving(false)
    }
  }

  return (
    <CCard className="p-3">
      <h3 style={{ marginBottom: 24 }}>Parametri sistem</h3>
      {error && <Alert type="error" message={error} style={{ marginBottom: 16 }} />}
      {loading ? <Spin /> : params && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Checkbox
            checked={!!params.preventDuplicateOffers}
            onChange={e => handleChange('preventDuplicateOffers', e.target.checked)}
            disabled={saving}
          >
            <span style={{ fontWeight: 500 }}>Previne înregistrări duplicate în Oferte Prețuri și Cereri de Ofertă</span>
            <div style={{ color: '#888', fontSize: 12, marginTop: 2 }}>
              Dacă o înregistrare nouă coincide cu una existentă ca Part Number, Firmă, Preț și Dată — nu se adaugă.
            </div>
          </Checkbox>
        </div>
      )}
    </CCard>
  )
}

export default Parametri
